const { default: server } = require("./server");

export const getAllContactUssApi = async () => {
  const response = await server().get("/contactUs");

  return response.data;
};

export const editContactUsApi = async ({ data, id }) => {
  const response = await server().put(`/contactUs/${id}`, data);

  return response.data;
};

export const getContactUsApi = async (id) => {
  const response = await server().get(`/contactUs/${id}`);

  return response.data;
};

export const deleteContactUsApi = async (id) => {
  const response = await server().delete(`/contactUs/${id}`);

  return response.data;
};

export const addContactUsApi = async (data) => {
  const response = await server().post("/contactUs", data);

  return response.data;
};
